'use strict';

/**
 * Colivings nativos visibles solo cuando la búsqueda está acotada a Canarias
 * (no en hub nacional /encuentratucoliving sin ciudad).
 */
const CANARY_ISLANDS_ONLY_NATIVE_COLIVING_IDS = new Set([
  'NIIh4wIkPqOWg3sNnUM6', // Bencomo Coliving
]);

const CANARY_LOCATION_TOKENS = [
  'las palmas',
  'tenerife',
  'santa cruz de tenerife',
  'gran canaria',
  'canarias',
  'islas canarias',
];

function normalizeLocationToken(text) {
  return String(text || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim();
}

function isCanaryLocationToken(normalized) {
  if (!normalized) return false;
  return CANARY_LOCATION_TOKENS.some(
    (token) => normalized === token || normalized.includes(token) || token.includes(normalized),
  );
}

/** Etiqueta de UI / propertyLocation (ej. "Las Palmas", "Tenerife"). */
function isCanaryIslandsLocationLabel(label) {
  return isCanaryLocationToken(normalizeLocationToken(label));
}

/**
 * @param {object} options
 * @param {string[]} [options.normalizedLocationFilters]
 * @param {string} [options.propertyLocation]
 * @param {string} [options.propertyLocations] comma-separated
 */
function isCanaryIslandsSearchScope(options = {}) {
  const tokens = new Set();
  for (const t of options.normalizedLocationFilters || []) {
    tokens.add(normalizeLocationToken(t));
  }
  if (options.propertyLocation && String(options.propertyLocation).trim()) {
    tokens.add(normalizeLocationToken(options.propertyLocation));
  }
  if (options.propertyLocations && String(options.propertyLocations).trim()) {
    for (const part of String(options.propertyLocations).split(',')) {
      const trimmed = part.trim();
      if (trimmed) tokens.add(normalizeLocationToken(trimmed));
    }
  }
  if (tokens.size === 0) return false;
  return [...tokens].some(isCanaryLocationToken);
}

/**
 * @param {string} colivingId
 * @param {boolean} isCanaryIslandsSearch
 * @param {boolean} [isNativeListing=true]
 */
function shouldIncludeNativeColivingInSearch(colivingId, isCanaryIslandsSearch, isNativeListing = true) {
  if (!isNativeListing) return true;
  const id = String(colivingId || '');
  if (!CANARY_ISLANDS_ONLY_NATIVE_COLIVING_IDS.has(id)) return true;
  return isCanaryIslandsSearch === true;
}

function filterSearchResultsForCanaryNativeRules(results, isCanaryIslandsSearch) {
  if (!Array.isArray(results)) return [];
  return results.filter((item) =>
    shouldIncludeNativeColivingInSearch(
      item?.id,
      isCanaryIslandsSearch,
      item?.isNative !== false && item?.isExternal !== true,
    ),
  );
}

module.exports = {
  CANARY_ISLANDS_ONLY_NATIVE_COLIVING_IDS,
  isCanaryIslandsLocationLabel,
  isCanaryIslandsSearchScope,
  shouldIncludeNativeColivingInSearch,
  filterSearchResultsForCanaryNativeRules,
};
